import request from '@/utils/request';

export function repairDocumentList(params) {
    return request({ url: `/repair_documents/`, method: 'get', params })
}

export function repairDocumentCreate(data) {
    return request({ url: `/repair_documents/`, method: 'post', data })
}

export function repairDocumentUpdate(data) {
    return request({ url: `/repair_documents/${data.id}/`, method: 'put', data })
}

export function repairDocumentDestroy(data) {
    return request({ url: `/repair_documents/${data.id}/`, method: 'delete', data })
}